import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * El libro de la caja de ahorro, dentro del grupo `_contabilidad`.
 *
 * `rep.movimiento_caja_ahorro` le contesta `E_ROL_NO_AUTORIZADO` al operario en vez de una lista
 * vacía, que se leería como un mes sin movimiento, así que el público de esta pantalla es el de
 * este grupo. La reposición de la caja menor, en cambio, va en `_operacion`: son dos cajas y dos
 * públicos, no una pantalla partida por comodidad.
 *
 * LLEVABA DESDE LA FASE 4 CONSTRUIDA, PROBADA Y SIN RUTA. Adjudicación 191.
 */
export const rutaCajaAhorro = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/caja-ahorro',
  component: lazyRouteComponent(() => import('./caja-ahorro-pantalla.js'), 'RutaCajaAhorro'),
});
